import { render, staticRenderFns } from "./base-component.vue?vue&type=template&id=8dbfffc6&scoped=true&lang=pug&"
import script from "./base-component.vue?vue&type=script&lang=ts&"
export * from "./base-component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dbfffc6",
  null
  
)

export default component.exports